/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventIndex: NonNullable<unknown> }} Event_Translation_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Translation Event {eventIndex}" |
*
* @param {Event_Translation_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_translation_aria_label = /** @type {((inputs: Event_Translation_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Translation_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Evenement de traduction ${i?.eventIndex}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Übersetzungsereignis ${i?.eventIndex}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Evento di traduzione ${i?.eventIndex}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Событие перевода ${i?.eventIndex}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Evento de traducción ${i?.eventIndex}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`翻译事件${i?.eventIndex}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`翻訳イベント ${i?.eventIndex}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अनुवाद घटना ${i?.eventIndex}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Evento de tradução ${i?.eventIndex}`)
	return /** @type {LocalizedString} */ (`Translation Event ${i?.eventIndex}`)
});